/**
 * This index.js file is the entry point for your component and
 * is referenced from package.json. It's best to keep it lightweight
 * and do all of your work in component and subcomponent files.
 **/

import Calendar from './Calendar/Calendar/Calendar';
import DatePicker from './DatePicker/DatePicker';
import DatePickerBase from './DatePickerBase/DatePickerBase';
import DateRangePicker from './DateRangePicker/DateRangePicker';
import NavCalendar from './NavCalendar/NavCalendar';
import * as dateUtils from './utils/dateUtils';

const NavCalendarMonth = NavCalendar; // Added for backwards compatibility

export {
    Calendar,
    DatePicker,
    DatePickerBase,
    DateRangePicker,
    dateUtils,
    NavCalendar,
    NavCalendarMonth,
};
